import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { SiteLayout } from './components/SiteLayout';
import { LoginPage } from './pages/LoginPage';
import { RegisterPage } from './pages/RegisterPage';
import { LandingPage } from './pages/LandingPage';
import { DashboardPage } from './pages/DashboardPage';
import { EditorPage } from './pages/EditorPage';
import { ApplyingPage } from './pages/ApplyingPage';
import { ProfilePage } from './pages/ProfilePage';
import { PublicResumePage } from './pages/PublicResumePage';
import { PublicTailoredPage } from './pages/PublicTailoredPage';
import { HistoryPage } from './pages/HistoryPage';

function App() {
    return (
        <ThemeProvider>
            <AuthProvider>
                <BrowserRouter>
                    <Routes>
                    <Route path="/" element={<LandingPage />} />
                    <Route path="/r/:publicId" element={<PublicResumePage />} />
                    <Route path="/t/:publicId" element={<PublicTailoredPage />} />
                        <Route path="/login" element={<LoginPage />} />
                        <Route path="/register" element={<RegisterPage />} />
                        <Route
                            element={
                                <ProtectedRoute>
                                    <SiteLayout />
                                </ProtectedRoute>
                            }
                        >
                        <Route path="/dashboard" element={<DashboardPage />} />
                        <Route path="/apply" element={<ApplyingPage />} />
                        <Route path="/history" element={<HistoryPage />} />
                        <Route path="/profile" element={<ProfilePage />} />
                        </Route>
                        <Route
                            path="/editor/:id"
                            element={
                                <ProtectedRoute>
                                    <EditorPage />
                                </ProtectedRoute>
                            }
                        />
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                </BrowserRouter>
            </AuthProvider>
        </ThemeProvider>
    );
}

export default App;
